import {Component, OnDestroy, OnInit} from '@angular/core';
import {DocumentInterruptSource, Idle, StorageInterruptSource} from '@ng-idle/core';
import {IndividualConfig, ToastrService} from 'ngx-toastr';
import {Subscription} from 'rxjs';
import {ConfigService} from '../services/config.service';
import {EventsEmitterService} from '../services/emitter.service';
import {LogService} from '../services/log.service';
import {SecurityService} from '../services/security.service';
import {VisualsService} from '../services/visuals.service';
@Component({
  selector: 'app-dashboard',
  templateUrl: './full-layout.component.html',
})
export class FullLayoutComponent implements OnInit, OnDestroy {
  public link: string = '';
  public linkVisual: string = '';
  public currentYear = new Date().getFullYear();

  public CUSTOM_INTERRUPTSOURCE: any[] = [
    new DocumentInterruptSource('keydown mousedown'),
    new StorageInterruptSource(),
  ];

  public resetTimerAnimation: boolean = true;

  public timer: string;
  public timerActive: boolean;

  public toastrSubscription: Subscription;

  public toastrConfig: Partial<IndividualConfig> = {
    timeOut: 7000,
    positionClass: 'toast-top-right',
    newestOnTop: false,
    progressBar: true,
    progressAnimation: 'increasing',
  };

  public genericVis = {};

  constructor(
    public securityService: SecurityService,
    public eventsEmitterService: EventsEmitterService,
    public logger: LogService,
    public idle: Idle,
    public configService: ConfigService,
    public visualsService: VisualsService,
    public toastr: ToastrService,
  ) {
    this.loadVisuals();
    this.eventsEmitterService.languageChange.subscribe({
      next: (langId) => {
        this.loadVisuals();
      },
    });

    // disable Timer from config file during tests
    this.timerActive = this.configService.getTimer();
    if (this.timerActive) {
      // sets an idle timeout of 1 seconds, for testing purposes.
      idle.setIdle(1);
      // sets a timeout period of 5 seconds. after 10 minutes of inactivity, the user will be considered timed out.
      idle.setTimeout(600);
      // sets the custom interrupts, in this case, things like clicks, scrolls, touches to the document
      idle.setInterrupts(this.CUSTOM_INTERRUPTSOURCE);

      idle.onInterrupt.subscribe({
        next: () => {
          this.resetTimerAnimation = false;
        },
      });

      idle.onTimeoutWarning.subscribe({
        next: (countdown: number) => {
          this.resetTimerAnimation = true;
          this.timer = this.formatTime(countdown);
          //this.logger.log('TimeoutWarning: ' + countdown);
        },
      });

      idle.onTimeout.subscribe({
        next: () => {
          this.securityService.logout(true);
        },
      });

      idle.watch();
    }

    this.getFooterLink();

    this.toastrSubscription = LogService.alertCreate.subscribe({
      next: (alertJSON) => {
        if (alertJSON.hasOwnProperty('type')) {
          switch (alertJSON.type) {
            case 'error':
              this.toastr.error(alertJSON.body, this.genericVis[alertJSON.type], this.toastrConfig);
              break;

            case 'success':
              this.toastr.success(
                alertJSON.body,
                this.genericVis[alertJSON.type],
                this.toastrConfig,
              );
              break;

            case 'info':
              this.toastr.info(alertJSON.body, this.genericVis[alertJSON.type], this.toastrConfig);
              break;

            case 'warning':
              this.toastr.warning(
                alertJSON.body,
                this.genericVis[alertJSON.type],
                this.toastrConfig,
              );
              break;

            default:
              this.toastr.error(alertJSON.body, this.genericVis['error'], this.toastrConfig);
          }
        } else {
          this.toastr.error(alertJSON.body, 'Error', this.toastrConfig);
        }
      },
    });
  }

  public loadVisuals(): void {
    this.genericVis = this.visualsService.getFromStorageAsJSON('visualsArray')
      ? this.visualsService.getFromStorageAsJSON('visualsArray')['generic']
      : {};
  }

  ngOnInit(): void {}

  ngOnDestroy() {
    // Will clear when component is destroyed e.g. route is navigated away from.
    this.idle.stop();
    this.idle.onIdleStart.observers.length = 0;
    this.idle.onIdleEnd.observers.length = 0;
    this.idle.onTimeoutWarning.observers.length = 0;
    this.idle.onTimeout.observers.length = 0;
    this.idle.onInterrupt.observers.length = 0;
    this.toastrSubscription.unsubscribe();
  }

  public formatTime(time: number): string {
    let minutes = Math.floor(time / 60);
    let seconds = time - minutes * 60;
    let finalTime = this.str_pad_left(minutes, '0', 2) + ':' + this.str_pad_left(seconds, '0', 2);
    return finalTime;
  }

  public str_pad_left(string, pad, length) {
    return (new Array(length + 1).join(pad) + string).slice(-length);
  }

  public getFooterLink() {
    this.visualsService.getParam('ADM_FOOTER_LINK').subscribe({
      next: (data) => {
        this.link = data.paramValStr;
      },
    });
    this.visualsService.getParam('ADM_FOOTER_VISUAL').subscribe({
      next: (data) => {
        this.linkVisual = data.paramValStr;
      },
    });
  }
}
